<template>
  <div>
    <custom-callout :has-toggle="false" class="mt-2" border-color="gray">
      <div class="row mt-2 pb-3">
        <div class="col-md-10 pt-3">
          <div class="row">
            <div class="col-md-3 col-12">
              <div class="info-text-title">
                Título:
              </div>
              <p class="info-text">
                {{ value.title }}
              </p>
            </div>
            <div class="col-md-3 col-12">
              <div class="info-text-title">
                Autor:
              </div>
              <p class="info-text">
                {{ value.author }}
              </p>
            </div>
            <div class="col-md-3 col-12">
              <div class="info-text-title">
                Casa Editorial:
              </div>
              <p class="info-text">
                {{ value.publisher }}
              </p>
            </div>
            <div class="col-md-3 col-12">
              <div class="info-text-title">
                ISBN:
              </div>
              <p class="info-text">
                {{ value.isbn }}
              </p>
            </div>
            <div class="col-md-3 col-12">
              <div class="info-text-title">
                Materia:
              </div>
              <p class="info-text">
                {{ value.subject }}
              </p>
            </div>
            <div class="col-md-3 col-12">
              <div class="info-text-title">
                Grado:
              </div>
              <p class="info-text">
                {{ value.grade }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-2 pt-3">
          <div :class="['row w-100', { 'float-right': !isMobile }]">
            <dropdown
              :class="['w-100 ml-4', { 'pl-c': isMobile }]"
              name="Actions"
              :title="'Acciones'"
              :items="booksOptions"
            />
          </div>
        </div>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import dropdown from 'dropdown';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    dropdown,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      booksOptions: [
        {
          label: 'Entrar',
          icon: 'fas fa-file-import color-primary-1',
          border: 'bottom',
          click: () => {
            this.$router.push(`/books/BooksCatalog/read/${this.value.bookId}`);
          },
        },
        {
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1',
          border: 'bottom',
          click: () => {
            this.$router.push(`/books/BooksCatalog/edit/${this.value.bookId}`);
          },
        },
        {
          label: 'Eliminar',
          icon: 'fas fa-times-circle text-red',
          click: () => this.$emit('deleteBook', this.value),
        },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
};
</script>

<style scoped>
::v-deep .info-text-title {
  color: #727272;
  font-size: 16px;
  font-weight: normal;
}

::v-deep .info-text {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}

::v-deep .custom-class:not(:hover) {
  background: transparent !important;
}

::v-deep .ac-btn:not(:hover) {
  background: transparent !important;
}

@media only screen and (max-width: 375px) {
  ::v-deep .ac-btn {
    width: 100%;
  }

  ::v-deep .info-text-title {
    color: #727272 !important;
    font-size: 14px !important;
    font-weight: normal !important;
  }

  ::v-deep .info-text {
    color: #11291b !important;
    font-weight: normal !important;
    font-size: 14px !important;
  }
}
</style>
